import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div className="min-h-[80svh] flex flex-col items-center justify-center px-5 text-center">
      <p className="eyebrow justify-center">[ 404 ]</p>
      <h1 className="hero-headline mt-6 max-w-3xl">This page hasn’t been drawn yet.</h1>
      <p className="body-text mt-6 max-w-lg">
        The page you’re looking for isn’t part of the site. Let’s bring you back to safe ground.
      </p>
      <Link to="/" className="btn-primary mt-10">
        <ArrowLeft className="h-4 w-4" /> Back Home
      </Link>
    </div>
  );
}
